module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header collapse d-lg-flex p-0",
    attrs: {
      "id": "headerMenuCollapse"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg order-lg-first"
  }, [_c('ul', {
    staticClass: "nav nav-tabs border-0 flex-column flex-lg-row"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'active': _vm.isActive('Horaires')
    },
    attrs: {
      "to": {
        name: 'Horaires'
      }
    }
  }, [_c('i', {
    staticClass: "fe fe-calendar"
  }), _vm._v(" Horaires des collectes\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'TypesCollectes'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "fe fe-truck"
  }), _vm._v(" Types de collectes\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'Ecocentres'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "fe fe-disc"
  }), _vm._v(" Écocentres\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'Recherche'
      },
      "active-class": "active"
    }
  }, [_c('i', {
    staticClass: "fe fe-search"
  }), _vm._v(" Recherche\n            ")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32d0c2b2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 572
// module chunks = 2